<template>
  <form class="space-y-6" @submit="onSubmit">
    <FormInputPassword
      name="password"
      label="New Password"
      autocomplete="new-password"
    />
    <FormInputPassword
      name="passwordConfirm"
      label="Confirm New Password"
    />

    <FormSubmitButton
      class="w-full"
      :is-loading="isSubmitting"
    >
      Update Password
    </FormSubmitButton>
  </form>
</template>

<script setup lang="ts">
import * as z from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import router from "@/router"

const createEditUserFormSchema = z
  .object({
    password: z
      .string()
      .min(1, "Password must not be empty"),
    passwordConfirm: z.string(),
  })
  .superRefine((params, ctx) => {
    if (params.password !== params.passwordConfirm) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Passwords must match",
        path: ["passwordConfirm"],
      })
    }
  })

const { handleSubmit, isSubmitting, setErrors } = useForm({
  validationSchema: toTypedSchema(createEditUserFormSchema),
  initialValues: {
    password: "",
    passwordConfirm: "",
  },
})

const onSubmit = handleSubmit(async (params) => {
  try {
    await updatePassword(params)

    toast.success("Password updated!")
    router.push({
      name: "home",
    })
  } catch (error) {
    if (error instanceof ApiError) {
      setErrors(error.requestErrors?.body ?? {})
    }
    toast.error("Failed to update password")
  }
})
</script>
